export const validateHost = (url: URL) => {
    return /^([A-Za-z0-9]+\.)*clickmeeting\.com$/.test(url.host);
};

export const validateProtocol = (url: URL) => {
    const protocolWithoutColon = url.protocol.slice(0, -1);
    return /^https$/.test(protocolWithoutColon);
};

// WARNING: This function must be used inside Nuxt scope
export const getEnvRelatedUrl = (path: string, baseUrl: string) => {
    try {
        const { href } = new URL(path, baseUrl);
        return href;
    } catch (error: unknown) {
        console.error(error);
        return '';
    }
};

export type GetEnvRelatedUrlFn = (path: string) => string;

// WARNING: This function must be used inside Nuxt scope
export const getEnvRelatedBaseUrl: GetEnvRelatedUrlFn = (path: string) => {
    // Using composable outside Nuxt is a bad practice
    // but we couldn't get this working with process.env
    const config = useRuntimeConfig();
    return getEnvRelatedUrl(path, config.public.baseUrl);
};

// WARNING: This function must be used inside Nuxt scope
export const getEnvRelatedCdnUrl: GetEnvRelatedUrlFn = (path: string) => {
    // Using composable outside Nuxt is a bad practice
    // but we couldn't get this working with process.env
    const config = useRuntimeConfig();
    return getEnvRelatedUrl(path, config.app.cdnURL);
};
